export const exportExcelSurveysService = (fetchData) => async (filters) => {
  try {
    const searchParams = new URLSearchParams({
      ...filters,
      initialDate: filters.initialDate,
      finalDate: filters.finalDate,
    }).toString();
    const response = await fetchData({
      url: "/api/v1/inspeccion-vehiculos/exportar-encuestas?" + searchParams,
    });

    return response;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error exporting surveys to Excel"
    );
  }
};
